import accessibleAutocomplete from 'accessible-autocomplete';
import { componentId, debounce } from '../../util';

const unpackJsonP = r => r.split(')').slice(0, -1).join(')').substr(2);

/**
 * @param {Response} response
 */
const suggestionQueryError = response => {
    throw new Error(`Error fetching data (${response.status}): ${response.statusText}`);
};

export const query = queryString =>
    fetch(`/?type=7384&L=0&tx_solr[queryString]=${queryString}&tx_solr[callback]=q`, {
        credentials: 'same-origin',
    })
        .then(r => {
            if (r.ok) return r.text();
            throw suggestionQueryError(r);
        })
        .then(r => unpackJsonP(r))
        .then(r => JSON.parse(r));

const suggestionAutocompleteId = 'search-autocomplete';

const suggestionQuery = query;

const suggestionSource = (query, populateResults) => {
    suggestionQuery(query)
        .then(d => Object.keys(d.suggestions || {}))
        .then(d => populateResults(d))
        .catch(() => populateResults([]));
};

/**
 * @param {HTMLElement} element
 */
export const autocomplete = function(element) {
    const container = element.parentNode;
    const elId = element.id || (suggestionAutocompleteId + '_' + componentId());
    element.id = 'placeholder_' + componentId();
    const initialValue = element.value;
    const wasFocused = element === document.activeElement;
    let initialValueChanged = false;
    const options = {
        element: container,
        id: elId,
        source: debounce((query, populateResults) => {
            if (query !== initialValue) {
                initialValueChanged = true;
            }
            if (query && initialValueChanged) {
                suggestionSource(query, populateResults);
            } else {
                populateResults([]);
            }
        }, 600),
        name: element.name,
        showNoOptionsFound: false,
        tNoResults: () => 'Keine Treffer',
        tStatusNoResults: () => 'Keine Treffer',
        tStatusResults: (length, contentSelectedOption) =>
            `${length} Treffer ${length > 1 ? 'sind' : 'ist'} verfügbar. ${contentSelectedOption}`,
        tStatusSelectedOption: (selectedOption, length) => `${selectedOption} (1 von ${length}) ist ausgewählt.`,
    };
    if (element.hasAttribute('placeholder')) {
        options.placeholder = element.getAttribute('placeholder');
    }
    accessibleAutocomplete(options);
    const input = container.querySelector(`#${elId}`);
    const wrapper = input.parentNode.parentNode;
    container.insertBefore(wrapper, element);
    input.value = initialValue;
    input.type = element.type;
    if (wasFocused) {
        input.focus();
    }
    element.remove();
};